(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  function initializeVaultEnquiry() {
    const field = document.getElementById('ContactForm-enquiry');
    if (!field) return;
    const enquiry = new URLSearchParams(window.location.search).get('enquiry');
    if (enquiry === 'story') field.value = 'Story submission';
    if (enquiry === 'general') field.value = 'General enquiry';
  }
  initializeVaultEnquiry();
  document.addEventListener('DOMContentLoaded', initializeVaultEnquiry);
  document.addEventListener('shopify:section:load', initializeVaultEnquiry);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
  const vaultStockHeader = document.querySelector('[data-vault-default-availability]');
  if (vaultStockHeader && !window.Shopify?.designMode) {
    const vaultStockUrl = new URL(window.location.href);
    if (!vaultStockUrl.searchParams.has('filter.v.availability')) {
      vaultStockUrl.searchParams.set('filter.v.availability', '1');
      vaultStockUrl.searchParams.delete('page');
      window.location.replace(vaultStockUrl.toString());
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vault-film-hero"] && !Shopify.designMode) return;
  try {
    
function initializeVaultFilm(root){
  root.querySelectorAll('[data-vault-film]').forEach(hero=>{
    if(hero.dataset.initialized)return;
    const video=hero.querySelector('.vault-film-hero__media video');
    const button=hero.querySelector('[data-film-toggle]');
    if(!video||!button)return;
    hero.dataset.initialized='true';
    const playLabel=button.textContent;
    const pauseLabel=hero.dataset.pauseLabel;
    const reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)');
    const sync=()=>{
      button.textContent=video.paused?playLabel:pauseLabel;
      button.setAttribute('aria-label',button.textContent);
      button.setAttribute('aria-pressed',String(!video.paused));
    };
    video.addEventListener('play',sync);
    video.addEventListener('pause',sync);
    button.addEventListener('click',()=>video.paused?video.play().catch(sync):video.pause());
    const mobileTemplate=hero.querySelector('[data-film-mobile]');
    if(mobileTemplate){
      const mobilePlayer=mobileTemplate.content.querySelector('video');
      const desktopChildren=Array.from(video.childNodes).map(node=>node.cloneNode(true));
      const desktopPoster=video.getAttribute('poster');
      const mobileScreen=window.matchMedia('(max-width: 749px)');
      const selectFilm=()=>{
        const resume=!video.paused;
        video.pause();
        const children=mobileScreen.matches?Array.from(mobilePlayer.childNodes):desktopChildren;
        video.replaceChildren(...children.map(node=>node.cloneNode(true)));
        const poster=mobileScreen.matches?mobilePlayer.getAttribute('poster'):desktopPoster;
        if(poster)video.setAttribute('poster',poster);
        else video.removeAttribute('poster');
        video.load();
        if(resume&&!reducedMotion.matches)video.play().catch(sync);
      };
      selectFilm();
      mobileScreen.addEventListener('change',selectFilm);
      const unload=event=>{
        if(event.target.contains(hero)){
          mobileScreen.removeEventListener('change',selectFilm);
          document.removeEventListener('shopify:section:unload',unload);
        }
      };
      document.addEventListener('shopify:section:unload',unload);
    }
    if(!reducedMotion.matches)video.play().catch(sync);
    sync();
    hero.querySelector('[data-film-scroll]').addEventListener('click',()=>{
      let next=hero.closest('.shopify-section').nextElementSibling;
      while(next&&!next.getClientRects().length)next=next.nextElementSibling;
      if(next)next.scrollIntoView({behavior:reducedMotion.matches?'instant':'smooth',block:'start'});
    });
    const dialog=hero.querySelector('dialog');
    const watch=hero.querySelector('[data-film-watch]');
    if(dialog&&watch){
      const player=dialog.querySelector('video');
      let resume=false;
      watch.addEventListener('click',()=>{
        resume=!video.paused;
        video.pause();
        dialog.showModal();
        player.play().catch(()=>{});
      });
      hero.querySelector('[data-film-close]').addEventListener('click',()=>dialog.close());
      dialog.addEventListener('close',()=>{
        player.pause();
        if(resume&&!reducedMotion.matches)video.play().catch(sync);
      });
    }
  });
}
function updateVaultFilmHeader(){
  const hero=document.querySelector('[data-vault-film][data-header-overlay="true"]');
  const header=document.querySelector('.section-header');
  document.documentElement.classList.toggle('vault-film-page',Boolean(hero&&header));
  document.documentElement.classList.toggle('vault-film-over-header',Boolean(hero&&header&&window.scrollY<40));
  if(header)document.documentElement.style.setProperty('--vault-header-height',header.getBoundingClientRect().height+'px');
}
let vaultFilmHeaderFrame;
function scheduleVaultFilmHeader(){
  if(vaultFilmHeaderFrame)return;
  vaultFilmHeaderFrame=requestAnimationFrame(()=>{vaultFilmHeaderFrame=null;updateVaultFilmHeader();});
}
initializeVaultFilm(document);
updateVaultFilmHeader();
window.addEventListener('scroll',scheduleVaultFilmHeader,{passive:true});
window.addEventListener('resize',scheduleVaultFilmHeader);
document.addEventListener('shopify:section:load',event=>{initializeVaultFilm(event.target);updateVaultFilmHeader();});
document.addEventListener('shopify:section:unload',()=>requestAnimationFrame(updateVaultFilmHeader));
const vaultHeader=document.querySelector('.section-header');
if(vaultHeader)new ResizeObserver(scheduleVaultFilmHeader).observe(vaultHeader);

  } catch(e) { console.error(e); }
})();
})();
